import { useEffect, useState } from "react";

export default function Main() {
  const [advice, setAdvice] = useState({
    advice: "",
    id: 0,
  });
  const getData = async () => {
    const response = await fetch("https://api.adviceslip.com/advice")
      .then((res) => res.json())
      .catch((err) => {
        console.log("error", err);
      });
    // setAdvice({ advice: response.slip.advice, id: response.slip.id });
    setAdvice({ ...response.slip });
  };
  useEffect(() => {
    getData();
  }, []);
  const newAdvice = () => {
    getData();
  };
  return (
    <main>
      <h3>
        ADVICE <span>#{advice.id}</span>
      </h3>
      <p>"{advice.advice}"</p>
      <div className="line">
        <img alt="" src="./images/pattern-divider-desktop.svg" />
      </div>
      <div className="dice" onClick={newAdvice}>
        <img alt="" src="./images/icon-dice.svg" />
      </div>
    </main>
  );
}
